var map = {
	"./app.dev.aerosimple.com/favicon.png": 1825,
	"./app.dev.aerosimple.com/logo.png": 1826,
	"./default/favicon.png": 1827,
	"./default/logo.png": 1828,
	"./gcr.unosimple.com/favicon.ico": 1829,
	"./gcr.unosimple.com/logo.jpg": 1830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1824;